// From Mueller.Business.Models.Calc.CalcToolCodes

export enum CalcToolCodes {
  Rct = "RCT",
  Iso = "ISO",
  RctExpressLync = "RCT_ExpressLync",
  RctFit = "RCT_FIT",
  Vedder = "VEDDER",
  RctHighValue = "RCT_High_Value",
  E2Value = "E2VALUE",
  RsMeans = "RSMEANS",
  RctHv = "RCT_HV",
  Cbvs = "CBVS",
  Calc360Value = "360VALUE"
};